
  import createMeisterIcons from '../src/createMeisterIcons';

  const Add = createMeisterIcons("add", [["path",{"fill":"currentColor","d":"M12 3.25a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 .75-.75","key":"81eb63c9c655f3e28f06144b46a67df45af461fa","fillRule":"evenodd","clipRule":"evenodd"}],["path",{"fill":"currentColor","d":"M3.25 12a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75","key":"cf8158479367dbdbd53d0a25778969e5e6fef0e4","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Add
  